const getCategoriesInfo = require("./getCategoriesInfo");
const config = getCategoriesInfo();

module.exports = async function findCategory(relationships) {
	let category_field_names = config.categories
		? config.categories.map((category) => category.field)
		: [];
	let categories = [];
	if (relationships) {
		for (let category_field_name of category_field_names) {
			if (relationships[category_field_name] && relationships[category_field_name].data) {
				let category_data = relationships[category_field_name].data;
				if (!Array.isArray(category_data)) {
					category_data = [category_data];
				}
				for (let catData of category_data) {
					categories.push({
						type: catData.type,
						id: catData.id,
						meta: catData.meta,
					});
				}
			}
		}
	}
	return categories.length > 0 ? categories : null;
};
